// extracted by mini-css-extract-plugin
export var dark = "x_tf";
export var darkcookie = "x_tg";
export var tintedcookie = "x_th";
export var regularcookie = "x_tj";
export var darkbase = "x_tk";
export var tintedbase = "x_tl";
export var regularbase = "x_tm";
export var darkraw = "x_tn";
export var tintedraw = "x_tp";
export var regularraw = "x_tq";
export var darkchick = "x_tr";
export var tintedchick = "x_ts";
export var regularchick = "x_tt";
export var darkherbarium = "x_tv";
export var tintedherbarium = "x_tw";
export var regularherbarium = "x_tx";
export var darkholiday = "x_ty";
export var tintedholiday = "x_tz";
export var regularholiday = "x_tB";
export var darkoffline = "x_tC";
export var tintedoffline = "x_tD";
export var regularoffline = "x_tF";
export var darkorchid = "x_tG";
export var tintedorchid = "x_tH";
export var regularorchid = "x_tJ";
export var darkpro = "x_tK";
export var tintedpro = "x_tL";
export var regularpro = "x_tM";
export var darkrose = "x_tN";
export var tintedrose = "x_tP";
export var regularrose = "x_tQ";
export var darktimes = "x_tR";
export var tintedtimes = "x_tS";
export var regulartimes = "x_tT";
export var darkwagon = "x_tV";
export var tintedwagon = "x_tW";
export var regularwagon = "x_tX";